import React from 'react'
import {Helmet} from "react-helmet"
import { Link } from 'react-router-dom'
// import _ from 'lodash'
import PlayMedia from '~/core/components/PlayMedia'
import NewsSlider from './NewsSlider'
import NewsIndex from './NewsIndex'
import Synopsis from './Synopsis';
import Article from './Article';
import Zedlines from './Zedlines'
import { connect } from 'react-redux'
import { fetchFMProgramsIfNeeded } from '~/programs/actions'
import { fetchStoriesIfNeeded, fetchSlidesIfNeeded, fetchStoryIfNeeded, fetchZedlinesIfNeeded, resetActiveStory } from '~/news/actions'


class NewsArticle extends React.Component {

  constructor() {
    super();
    // Setting up initial state
    this.state = {
      newsSliderData: [],
      newsPackages: [],
      zedlines: [],
      programsFM: null,
      story: [],
      newsStories: 0,
      active: 'brisbane-line'
    }
    this.handleClick = this.handleClick.bind(this)
    this.debug = this.debug.bind(this)
    this.last = null
  }

  static fetchData(store, route, match) {
    if(match.params.id) {
      return Promise.all([
        store.dispatch(fetchStoryIfNeeded(match.params.id)),
        store.dispatch(fetchFMProgramsIfNeeded()),
        store.dispatch(fetchSlidesIfNeeded()),
        store.dispatch(fetchZedlinesIfNeeded()),
        store.dispatch(fetchStoriesIfNeeded(0))
      ])

    }
    return Promise.all([
      store.dispatch(fetchFMProgramsIfNeeded()),
      store.dispatch(fetchSlidesIfNeeded()),
      store.dispatch(fetchZedlinesIfNeeded()),
      store.dispatch(fetchStoriesIfNeeded(0)),
      store.dispatch(resetActiveStory())
    ])
  }

  componentWillUnmount() {
      document.getElementsByTagName('body')[0].className = '';
  }
  componentWillMount() {
    const { match, history, dispatch } = this.props

    dispatch(fetchFMProgramsIfNeeded())
    dispatch(fetchSlidesIfNeeded())
    dispatch(fetchZedlinesIfNeeded())
    //dispatch(fetchStoriesIfNeeded(0))
    console.log(match)

    let newsSliderSrc = "//jeff.4zzz.org.au/api/news-slider"
    let _this = this


    if(match.params.id) {
      this.getStory(match.params.id)
    }

    this.getNewsStories()

  }

  componentDidMount() {
		window.scrollTo(0, 0);
    document.getElementsByTagName('body')[0].className = 'news';
  }

  componentWillReceiveProps(newProps) {
    const { match, history, dispatch } = newProps
    let _this = this
    if(this.props.match.params.id != match.params.id ) {
      if(match.params.id ) {
        this.getStory(match.params.id)
        document.body.scrollTop = 0
      } else {
        dispatch(resetActiveStory())
        this.setState({
          story: {}
        })
      }
    }
  }

  getStory(id){
    const { dispatch } = this.props
    dispatch(fetchStoryIfNeeded(id))
  }

  makeActive(section) {
    if (typeof window !== 'undefined' && window.matchMedia("(max-width: 639px)").matches) {
      this.setState({active: section})
    }
  }

  getNewsStories(){
    const {dispatch} = this.props
    dispatch(fetchStoriesIfNeeded(this.state.newsStories))
  }


  handleClick() {
    this.setState(prevState => ({
      newsStories: prevState.newsStories + 1
    }), this.getNewsStories )
    console.log('did it')
  }


  debug(ev){
    if (this.last) {
      this.last.style.display = 'none'
    }

    ev.currentTarget.nextSibling.style.display = 'block'
    this.last = ev.currentTarget.nextSibling
  }
  render(){
    const { stories, newsSlides, zedlines, match } = this.props
    var story, author
    if(match.params.id && stories.articles[match.params.id]) {
      story = stories.articles[match.params.id]
      if (story.uid) {
        let author_id = story.uid[0].target_id
        if (stories.authors[author_id] && stories.authors[author_id][0]) {
          author = stories.authors[author_id][0]
        }
      }


    }

    /*let newsPackages = _.partition(this.state.newsPackages, function(n, index) {
      return index % 3
    })*/
    let newsPackages = []

    stories.items.forEach((n, i, a) => {
      if( i % 3 === 0) {
        newsPackages.push( n )
     }
      else if( i % 3 === 1 ) {
        if (a[i+1]) {
          newsPackages.push([n, a[i+1]])
        }
        else {
          newsPackages.push( n )
        }
      }
    })

    /*let newsPackages = []
    console.log(this.state.newsPackages.length)
    let col = []
    for ( let i = 0; i < this.state.newsPackages.length; i++) {         console.log(i)
      if( i % 3 === 0) {
        console.log('umm')
        newsPackages.push(this.state.newsPackages[i])
      }
      else {
        newsPackages.push(this.state.newsPackages[0])

        console.log('ahh')

      }
    }
    debugger;*/

    let Articles = newsPackages.map((article, index) => {
      //console.log(article)
      if (! Array.isArray(article)) {
        return(
          <Synopsis key={ 'la' + index} index={index} article={article} />
        )
      }
      else {
        return (
					<div className="two-columns">
					{ article.map( (a) => (
						<div className="column" key={a.nid}>
							<Synopsis key={ 'tc' + index} index={index} article={a} />
						</div>
						))
					}
					</div>

        )
      }

    })
    let NewsColumn = ''
    if (story && story.nid ) {
      NewsColumn = <Article story={story} />
    }
    else {
      NewsColumn = <div>

      <div className="slider-wrapper">
        <NewsSlider data={newsSlides.items} />
      </div>
      {Articles}
      <div className="more">
        <Helmet>
          <title>4ZZZ News</title>
          <meta name="description" content="4ZZZ has been providing independent news and current affairs since its inception in 1975. The newsroom is entirely volunteer based and provides Zedlines bulletins on the hour each weekday from 8-11AM, plus a dedicated one hour news and current-affairs program, Brisbane Line, from 12-1PM on Tuesday, Thursday, and Saturday." />
          <meta name="og:description" content="4ZZZ has been providing independent news and current affairs since its inception in 1975. The newsroom is entirely volunteer based and provides Zedlines bulletins on the hour each weekday from 8-11AM, plus a dedicated one hour news and current-affairs program, Brisbane Line, from 12-1PM on Tuesday, Thursday, and Saturday." />
          <meta property="og:title" content="4ZZZ News" />
          <meta property="og:image" content="/assets/4zzz-1021-boat.jpg" />
          <meta name="twitter:image" content="/assets/4zzz-1021-boat.jpg" />
          <meta property="og:type" content="website" />
        </Helmet>
        <div onClick={this.handleClick}>
          <i className="fa fa-asterisk" aria-hidden="true"></i><b>MORE STORIES</b></div>
        </div>
      </div>
    }




    var NewsCols = [
      { active: false, name: 'sidebar', content: <div key="1" className="sidebar news-col">
        <div className="container">
        </div>
      </div>},
      { active: true, name: 'brisbane-line', content: <div key="2" className="brisbane-line news-col">
        <h1 onClick={(e) => this.makeActive('brisbane-line', e)}></h1>
        <div className="container">
          {NewsColumn}
        </div>
      </div>},
      { active: false, name: 'zedlines', content: <div key="3" className="zedlines news-col">
        <div className="container">

        </div>
      </div>}
    ]
    var tofind = this.state.active
    NewsCols = NewsCols.map((item) => {if(item.name === tofind){ item.active = true } else {item.active = false} return item }  )
    if (typeof window !== 'undefined'  && window.matchMedia("(max-width: 639px)").matches) {
      // NewsCols = _.sortBy(NewsCols, 'active')
      NewsCols = NewsCols.sort(a => a.active ? 1 : -1 );
    }

    const Col = NewsCols.map((news, i) => news.content )

    return(
     <div className="content article">
      <div style={{ display: 'flex', justifyContent: 'center', alignContent: 'center' }}>
        <Link to="/news"><img className="logo" src="/assets/4zzz-news-mast.svg" alt="4ZZZ News Masthead" /></Link>
      </div>
      <div className="stories">
        {Col}
      </div>
    </div>
    )
  }
}

export default connect(state => {return { programsFM: state.programsFM, stories: state.stories, newsSlides: state.newsSlides, zedlines: state.zedlines } }) (NewsArticle)
